"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClickFreeModuleCloseSchema = void 0;
const baseSchema_1 = require("../baseSchema");
const baseClickSchema_1 = require("../baseSchema/baseClickSchema");
class ClickFreeModuleCloseSchema extends baseClickSchema_1.BaseClickSchema {
    constructor({ step }) {
        super({ componentName: 'FreeModuleModalCloseButton' });
        this.step = step;
        this.action = baseSchema_1.ActionsName.CLICK_FREE_MODULE_CLOSE;
    }
    getDataHubEventData() {
        return {
            ...super.prepare(),
            step: this.step,
            action: this.action
        };
    }
}
exports.ClickFreeModuleCloseSchema = ClickFreeModuleCloseSchema;
